import "./node_modules/bootstrap/scss/bootstrap.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "popper.js/dist/popper.min";
import "bootstrap/dist/js/bootstrap.min.js";
import "./src/components/layout.css";
import "./src/CSS/BlogPage.css";
import "./src/CSS/common.css";
import "./src/CSS/CustomImpact.css";
import "./src/CSS/navbar.css";
import "./src/CSS/OfferTable.css";
import "./src/CSS/QueryForm.css";